import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

import { FieldNumber, FieldText } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const type = useMemo(() => {
    switch (command.data.type) {
      case 0:
        return 'Airspeed';
      case 1:
        return 'Ground Speed';
      case 2:
        return 'Ascend Speed';
      case 3:
        return 'Descend Speed';
      default:
        break;
    }
  }, [command.data.type]);

  return (
    <div className={cx('container')}>
      <label>
        Type
        <div className={cx('fieldWrapper')}>
          <FieldText value={type} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Speed
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.speed} readOnly />
          <span className={cx('unit')}>m/s</span>
        </div>
      </label>
      {command.data.throttle && command.data.throttle !== -1 && (
        <label>
          Throttle
          <div className={cx('fieldWrapper')}>
            <FieldNumber value={command.data.throttle} readOnly />
            <span className={cx('unit')}>%</span>
          </div>
        </label>
      )}
    </div>
  );
};

export default Item;
